import InfoScreensSticky from 'views/lolly/carousel/InfoScreensSticky';
import img39 from 'assets/images/screens/39.jpg';
import img37 from 'assets/images/screens/37.jpg';

const slides = [
  {
    Name: "Invite your customer base for free",
    Description: "Convert customers on social media, from mailing lists, and from in -store purchases at no cost",
    Image: img39,
  },
  {
    Name: "Keep your customers engaged with perks",
    Description: "Use Lolly to keep all your customers informed of your brands' perks",
    Image: img37,
  },
];

const Slides = () => {
  return (
    <InfoScreensSticky data={slides} />
  );
};

export default Slides;
